import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily: "Halcom W00 Regular,League Spartan,sans-serif !important",
    label1: {
      color: "#203864",
      fontFamily: "Halcom W00 Regular,League Spartan,sans-serif !important",
      fontSize: "16px",
      lineHeight: "24px",
      verticalAlign: "middle",
    },
    label2: {
      color: "#203864",
      fontFamily: "League Spartan,sans-serif !important",
      fontSize: "12px",
      lineHeight: "18px",
      textTransform: "uppercase",
      "& svg": {
        width: "13px",
        marginLeft: "5px",
      },
    },
    data: {
      display: "block",
      fontFamily: "Halcom W00 Regular,League Spartan,sans-serif !important",
      fontSize: "16px",
      lineHeight: "20px",
      fontWeight: "bold",
    },
    notificationTitle: {
      display: "block",
      fontFamily: "Halcom W00 Regular,League Spartan,sans-serif !important",
      fontSize: "20px",
      lineHeight: "30px",
      fontWeight: "500",
      color: "#000000",
    },
    notificationTime: {
      display: "block",
      fontFamily: "Halcom W00 Regular,League Spartan,sans-serif !important",
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "500",
      color: "#A8A8A8",
    },
  },
});